const e=(e,t)=>{let o;return(...r)=>{clearTimeout(o),o=setTimeout((()=>e(...r)),t)}};export{e as debounce};
//# sourceMappingURL=events.js.map
